export const breakpoint = {
  tablet: 640,
  laptop: 1024,
  desktop: 1280,
}
